import { Link } from 'react-router-dom'
import { getFeaturedArticles } from '@/mocks/articles'

export default function FeaturedSection() {
  const featured = getFeaturedArticles()

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-2">
              精选推荐
            </h2>
            <p className="text-foreground-500">编辑团队精心甄选的优质色里番作品</p>
          </div>
          <Link
            to="/category/hot"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {featured.slice(0, 4).map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className={`group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer ${
                index === 0 ? 'md:col-span-2 md:flex' : ''
              }`}
            >
              <div className={`${index === 0 ? 'md:w-1/2' : ''} overflow-hidden`}>
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className={`w-full ${index === 0 ? 'md:h-full' : 'h-48'} object-cover group-hover:scale-105 transition-transform duration-500`}
                  loading={index > 1 ? 'lazy' : undefined}
                />
              </div>
              <div className={`p-5 ${index === 0 ? 'md:w-1/2 md:flex md:flex-col md:justify-center' : ''}`}>
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs px-2.5 py-1 rounded-full bg-primary-100 text-primary-700 font-medium">
                    {article.categoryName}
                  </span>
                  <span className="text-xs text-foreground-400">{article.publishDate}</span>
                </div>
                <h3 className={`font-heading font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors mb-2 ${
                  index === 0 ? 'text-xl md:text-2xl' : 'text-lg'
                }`}>
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-4">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-4 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-accent-500"></i>
                    {article.rating}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.views.toLocaleString()} 次浏览
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-user-line"></i>
                    {article.author}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  )
}